import React, { useEffect } from 'react';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import type { TextPropColor, TextPropVariant } from '@carnica/ui-kit/types';
import { withRenderFlag } from '@beef/react';

import { TWithShouldRenderProp } from 'types';
import { emitExtendCustomEvent } from 'hooks/useCustomEvent';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

type Props = {
  mainText: string;
  mainTextColor?: TextPropColor;
  mainTextVariant?: TextPropVariant;
  onMetricView?: (data: string) => void;
  secondaryText?: string;
  secondaryTextColor?: TextPropColor;
  secondaryTextVariant?: TextPropVariant;
  userType: string;
};

const _UnlimitedAccumulatorTextContent: React.FC<Props> = ({
  mainTextVariant,
  mainText,
  mainTextColor = 'primary',
  secondaryText,
  secondaryTextColor,
  secondaryTextVariant,
  userType,
  onMetricView,
}) => {
  emitExtendCustomEvent('receiveText', secondaryText);
  useEffect(() => {
    const data = JSON.stringify({
      userType,
      buttonType: 'ГБ и безлимит',
      optionSpeed: secondaryText,
    });
    onMetricView?.(data);
  }, []);

  return (
    <>
      <div className={cn('infinity-group')}>
        <Text className={cn('infinity-unit')} color={mainTextColor} variant={mainTextVariant}>
          <span className={cn('infinity-symbol')}>∞</span> {mainText}
        </Text>
      </div>
      {secondaryText && (
        <Text color={secondaryTextColor} variant={secondaryTextVariant}>
          {secondaryText}
        </Text>
      )}
    </>
  );
};

export const UnlimitedAccumulatorTextContent: TWithShouldRenderProp<
  typeof _UnlimitedAccumulatorTextContent
> = withRenderFlag(_UnlimitedAccumulatorTextContent);
